<!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
  _/                                                                                                                    _/
  _/      子画面定義：処理確認画面(STDSDC01C08ProcessingConfirmModal)  収集書類情報複写確認                                                   _/
  _/                                                                                                                    _/
_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/ -->
<template>
  <BaseModal :show="isConfirmShow">
    <div class="popup" :style="{ width: width }">
      <div class="popup-head">処理確認</div>
      <div class="popup-body blue">
        <!-- ****  メッセージ表示領域 **** -->
        <p class="errMsg title-ico ico-warning" v-show="errors != ''">
          <ErrorMessage isModalError :errors="errors"></ErrorMessage>
        </p>
        <p class="newline" v-if="textArea != ''">{{ textArea }}</p>
        <p class="newline" style="color: red" v-if="textAreaRed != ''">
          {{ textAreaRed }}
        </p>
        <hr v-if="isFirstLineShow" />
        <div v-show="isFileSelectedShow">
          <div
            class="frm-row"
            @dragenter="dragEnter"
            @dragleave="dragLeave"
            @dragover.prevent
            @drop.prevent="dropFile"
          >
            <div class="frm-file">
              <span class="frm-file-text">
                ここにファイルをドロップしてください。
                <br />または
              </span>
              <label class="frm-file-label">
                <input
                  class="frm-file-item"
                  type="file"
                  ref="file"
                  @click="
                    (e) => {
                      e.target.value = '';
                    }
                  "
                  @change="selectedFile"
                  multiple
                />
                <span class="frm-btn" type="button" tabindex="0"
                  >ファイルの選択</span
                >
              </label>
            </div>
          </div>
          <div class="modal">
            <div class="frm-row" v-for="(file, index) in files" :key="index">
              <span class="frm-label" style="word-break: break-all"
                >・{{ file.name }}</span
              >
            </div>
          </div>
        </div>
        <div class="modal">
          <div
            class="frm-row"
            style="margin-top: 0px"
            v-for="(file, index) in itemList"
            :key="index"
          >
            <div class="frm-item">
              <label class="frm-checkbox">
                <input type="checkbox" v-model="fileList" :value="file" />
                <span
                  class="checkbox-item"
                  tabindex="0"
                  @keydown.space.stop.prevent="toggleFile(file)"
                ></span>
                <span class="checkbox-text">{{ file.fileName }}</span>
              </label>
            </div>
          </div>
        </div>
        <hr v-if="deleteLine" />
        <hr v-if="isSecondLineShow" />
        <p class="supExplanation newline" v-if="subTextArea != ''">
          {{ subTextArea }}
        </p>
        <p
          class="supExplanation newline"
          style="color: red"
          v-if="subTextAreaRed != ''"
        >
          {{ subTextAreaRed }}
        </p>
        <div
          class="frm-row"
          v-if="regularCheck != '' || deleteCheck != '' || confirmCheck != ''"
        >
          <div class="frm-item">
            <label class="frm-checkbox">
              <input type="checkbox" v-model="approval" />
              <span
                style="min-width: 20px"
                tabindex="0"
                @keydown.space.stop.prevent="approval = !approval"
                class="checkbox-item"
              ></span>
              <span class="checkbox-text" v-if="regularCheck != ''">
                {{ regularCheck }}
              </span>
              <span class="checkbox-text" v-if="confirmCheck != ''">
                {{ confirmCheck }}
              </span>
              <span class="checkbox-text" v-if="deleteCheck != ''">
                <p style="color: red">{{ deleteCheck }}</p>
              </span>
            </label>
          </div>
        </div>
        <div
          class="supExplanationtBottom"
          style="color: red"
          v-if="subTextAreaBottom != ''"
        >
          <p class="supExplanation newline">
            {{ subTextAreaBottom }}
          </p>
        </div>
      </div>
      <div class="popup-foot blue">
        <div class="frm-btn-row footer-btn">
          <div class="frm-item grow center">
            <button
              tabindex="0"
              class="frm-btn strong large"
              @click="handleAgree"
              :disabled="isDisabled"
            >
              はい
            </button>
            <button
              tabindex="0"
              v-if="!noBtnHidden"
              class="frm-btn large"
              ref="disagreeButton"
              @click="handleDisagree"
            >
              いいえ
            </button>
          </div>
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import _ from "lodash";
import Common from "@/util/common";
import ErrorMessage from "@/components/ErrorMessage.vue";
import Validation from "@/util/validation.js";
import BaseModal from "@/components/Base/BaseModal.vue";

export default {
  components: {
    ErrorMessage,
    BaseModal,
  },
  name: "STDSDC01C08ProcessingConfirmModal",
  data() {
    return {
      isEnter: false,
      approval: false,
      files: [],
      fileList: [],
      errors: [],
    };
  },
  props: {
    isConfirmShow: {
      type: Boolean,
      required: true,
    },
    isFileSelectedShow: {
      type: Boolean,
    },
    textArea: {
      type: String,
      default: "",
    },
    textAreaRed: {
      type: String,
      default: "",
    },
    itemList: {
      type: Array,
      default() {
        return [];
      },
    },
    subTextArea: {
      type: String,
      default: "",
    },
    subTextAreaRed: {
      type: String,
      default: "",
    },
    subTextAreaBottom: {
      type: String,
      default: "",
    },
    regularCheck: {
      type: String,
      default: "",
    },
    confirmCheck: {
      type: String,
      default: "",
    },
    deleteCheck: {
      type: String,
      default: "",
    },
    deleteLine: {
      type: Boolean,
      default: false,
    },
    noBtnHidden: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: "530px",
    },
  },
  computed: {
    // **********************************************
    // はいボタン非活性、活性
    // **********************************************
    isDisabled() {
      if (this.files.length > 0 || this.fileList.length > 0) {
        return false;
      } else if (
        (this.textArea == "" || this.textAreaRed == "") &&
        !this.isFileSelectedShow &&
        this.files.length == 0 &&
        this.subTextArea != "" &&
        this.itemList.length == 0 &&
        (this.regularCheck == "" || this.deleteCheck == "") &&
        this.approval
      ) {
        return false;
      } else if (
        (this.textArea != "" || this.textAreaRed != "") &&
        !this.isFileSelectedShow &&
        this.files.length == 0 &&
        this.itemList.length == 0 &&
        (this.regularCheck != "" ||
          this.deleteCheck != "" ||
          this.confirmCheck != "") &&
        !this.approval
      ) {
        return true;
      } else if (
        (this.textArea != "" || this.textAreaRed != "") &&
        !this.isFileSelectedShow &&
        this.files.length == 0 &&
        this.itemList.length == 0 &&
        (this.regularCheck == "" || this.deleteCheck == "")
      ) {
        return false;
      } else if (
        (this.textArea != "" || this.textAreaRed != "") &&
        this.files.length == 0 &&
        this.isFileSelectedShow &&
        this.itemList.length > 0 &&
        this.subTextArea != "" &&
        (this.regularCheck != "" || this.deleteCheck != "") &&
        !this.approval
      ) {
        return true;
      }
      return true;
    },
    // **********************************************
    // 線非表示、表示
    // **********************************************
    isFirstLineShow() {
      if (
        this.textArea != "" &&
        this.itemList.length > 0 &&
        this.subTextArea != "" &&
        this.regularCheck != ""
      ) {
        return true;
      } else if (
        this.textArea != "" &&
        this.isFileSelectedShow &&
        this.subTextArea != "" &&
        this.regularCheck != ""
      ) {
        return false;
      } else if (this.textArea != "" && this.regularCheck != "") {
        return true;
      } else {
        return false;
      }
    },
    // **********************************************
    // 線非表示、表示
    // **********************************************
    isSecondLineShow() {
      if (
        this.textArea != "" &&
        this.isFileSelectedShow &&
        this.subTextArea != "" &&
        this.regularCheck != ""
      ) {
        return true;
      } else if (this.textArea != "" && this.deleteCheck != "") {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    isConfirmShow: function (newVal) {
      if (newVal) {
        this.$nextTick(function () {
          this.initFocus();
        });
      }
    },
  },
  methods: {
    // **********************************************
    // ファイルの選択
    // **********************************************
    selectedFile(e) {
      this.errors = [];
      let files = e.target.files || e.dataTransfer.files;
      for (var i = 0, f; (f = files[i]); i++) {
        // ファイルの拡張子をチェック
        if (Common.checkFileSuffix(f.name)) {
          this.errors.push(
            Common.createError("MTCL1107", Common.getMessage("MTCL1107", []))
          );
          return;
        }
        // ファイルのサイズをチェック
        if (Common.checkFileSize(f.size)) {
          this.errors.push(
            Common.createError("MTCL1053", Common.getMessage("MTCL1053"))
          );
          return;
        }
        // ファイル名にSJIS変換できない文字が含まれているかどうかのチェック
        if (
          Common.EscapeToSJIS(f.name) ||
          !Validation.checkNationalkinsokuchar(f.name)
        ) {
          this.errors.push(
            Common.createError(
              "MTCL1098",
              Common.getMessage("MTCL1098", ["ファイル名"])
            )
          );
          return;
        }
      }
      const realFiles = Array.from(files);

      const uniqFiles = realFiles.filter((realFile) => {
        const existFileIndex = this.files.findIndex(
          (e) => realFile.name === e.name
        );
        if (existFileIndex >= 0) {
          this.files[existFileIndex] = realFile;
          return false;
        }
        return true;
      });
      if (uniqFiles.length) {
        this.files.push(...uniqFiles);
        this.isEnter = false;
      }
    },
    // **********************************************
    // 領域にドラッグが入った時に実行
    // **********************************************
    dragEnter() {
      this.isEnter = true;
    },
    // **********************************************
    // 領域からドラッグが出た時に実行
    // **********************************************
    dragLeave() {
      this.isEnter = false;
    },
    dragOver() {},
    // **********************************************
    // 領域でドラッグしているものをドロップしたら実行
    // **********************************************
    dropFile(e) {
      this.errors = [];
      let files = e.dataTransfer.files;
      let realFiles = [];
      for (var i = 0, f; (f = files[i]); i++) {
        // iterate in the files dropped
        var entry = e.dataTransfer.items[i].webkitGetAsEntry();
        if (entry.isDirectory) {
          // The file is a folder
          this.errors.push(
            Common.createError("MTCL1106", Common.getMessage("MTCL1106", []))
          );
        } else {
          // The file is not a folder
          realFiles.push(f);
        }
        // ファイルの拡張子をチェック
        if (Common.checkFileSuffix(entry.name)) {
          this.errors.push(
            Common.createError("MTCL1107", Common.getMessage("MTCL1107", []))
          );
          return;
        }
        // ファイルのサイズをチェック
        if (Common.checkFileSize(f.size)) {
          this.errors.push(
            Common.createError("MTCL1053", Common.getMessage("MTCL1053"))
          );
          return;
        }
        // ファイル名にSJIS変換できない文字が含まれているかどうかのチェック
        if (
          Common.EscapeToSJIS(entry.name) ||
          !Validation.checkNationalkinsokuchar(entry.name)
        ) {
          this.errors.push(
            Common.createError(
              "MTCL1098",
              Common.getMessage("MTCL1098", ["ファイル名"])
            )
          );
          return;
        }
      }
      const uniqFiles = realFiles.filter((realFile) => {
        const existFileIndex = this.files.findIndex(
          (e) => realFile.name === e.name
        );
        if (existFileIndex >= 0) {
          this.files[existFileIndex] = realFile;
          return false;
        }
        return true;
      });
      if (uniqFiles.length) {
        this.files.push(...uniqFiles);
        this.isEnter = false;
      }
    },
    // **********************************************
    // はいボタンをクリック
    // **********************************************
    handleAgree() {
      this.errors = [];
      const filesTotalSize = this.files.reduce(
        (sum, e) => sum + Number(e.size || 0),
        0
      );

      // ファイルのサイズをチェック
      if (Common.checkFileSize(filesTotalSize)) {
        this.errors.push(
          Common.createError("MTCL1053", Common.getMessage("MTCL1053"))
        );
        return;
      }

      const result = {
        files: this.files,
        itemList: this.fileList,
        agreeCheckBox: this.approval,
      };
      this.$emit("agree", result);
      this.reset();
    },
    // **********************************************
    // いいえボタンをクリック
    // **********************************************
    handleDisagree() {
      this.$emit("disagree");
      this.reset();
    },
    // **********************************************
    // リセット
    // **********************************************
    reset() {
      this.approval = false;
      this.files = [];
      this.fileList = [];
      this.errors = [];
    },
    // **********************************************
    // 初期フォーカス設定
    // **********************************************
    initFocus() {
      this.$refs.disagreeButton?.focus();
    },
    // **********************************************
    // ファイルチェックボックス切り替え
    // **********************************************
    toggleFile(file) {
      if (this.fileList.some((item) => item.fileId === file.fileId)) {
        this.fileList = this.fileList.filter(
          (item) => item.fileId !== file.fileId
        );
      } else {
        this.fileList.push(file);
      }
    },
  },
};
</script>

<style scoped>
.modal {
  max-height: 6.5em;
  margin-top: 1em;
  overflow-x: hidden;
  overflow-y: auto;
}
.supExplanation {
  font-size: 1.3rem;
  margin-top: 8px;
  text-indent: -1em;
  margin-left: 1em;
}

.checkbox-item {
  margin: 0;
}
.supExplanationtBottom {
  margin-top: 1em;
}
.supExplanationtBottom p {
  margin-bottom: -20px;
}
</style>
